import { cn } from 'lib/cn';

/** Generic white surface used across the dashboard. */
export function Card({ className, padded = true, children, ...props }) {
  return (
    <div className={cn('panel', padded && 'p-4 sm:p-5', className)} {...props}>
      {children}
    </div>
  );
}

/** Optional header row for a Card (title + optional actions on the right). */
export function CardHeader({ title, subtitle, actions, className }) {
  return (
    <div className={cn('mb-4 flex items-start justify-between gap-3', className)}>
      <div>
        {title && <h3 className="text-base font-semibold text-slate-900">{title}</h3>}
        {subtitle && <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

export default Card;
